import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-section">
          <h3>Contact</h3>
          <p>
            packs@houndandhome.xyz
            <br />3 Duchess Pl, Singapore 269044
          </p>
        </div>
        <div className="footer-section">
          <h3>Discover</h3>
          <Link to="/about" onClick={toTop}>
            About us
          </Link>
        </div>
        <div className="footer-section">
          <h3>Customer care</h3>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns &amp; Exchanges
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Shipping &amp; Delivery
          </Link>
          <Link to="/refunds" onClick={toTop}>
            Refund Policy
          </Link>
          <Link to="/order-cancellations" onClick={toTop}>
            Order Changes
          </Link>
          <Link to="/jewellery-care" onClick={toTop}>
            Jewellery Care
          </Link>
          <Link to="/warranty-repairs" onClick={toTop}>
            Warranty &amp; Repairs
          </Link>
        </div>
        <div className="footer-section">
          <h3>Policies</h3>
          <Link to="/policies" onClick={toTop}>
            All Policies
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy Policy
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms of Service
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie &amp; Local Storage
          </Link>
          <Link to="/payment-security" onClick={toTop}>
            Payment &amp; Security
          </Link>
          <Link to="/complaints" onClick={toTop}>
            Complaints
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            Accessibility
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; Hound &amp; Home 2026 · houndandhome.xyz</p>
      </div>
    </footer>
  );
}

export default Footer;
